import { render, staticRenderFns } from "./editRemittancesTable.vue?vue&type=template&id=b41eb644"
import script from "./editRemittancesTable.vue?vue&type=script&lang=js"
export * from "./editRemittancesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports